export const USER_ROLES = {
  SUPERADMIN: 'superadmin',
  ADMIN: 'admin',
  USER: 'user',
} as const;

export type UserRole = typeof USER_ROLES[keyof typeof USER_ROLES];

export const ADMIN_ROLE_VALUES: ReadonlyArray<UserRole> = [USER_ROLES.SUPERADMIN, USER_ROLES.ADMIN];
export const SUPERADMIN_ROLE_VALUES: ReadonlyArray<UserRole> = [USER_ROLES.SUPERADMIN];

export const ROLE_OPTIONS: ReadonlyArray<{ value: UserRole; label: string }> = [
  { value: USER_ROLES.USER, label: 'User' },
  { value: USER_ROLES.ADMIN, label: 'Admin' },
  { value: USER_ROLES.SUPERADMIN, label: 'Super Admin' },
];

export const ROLE_COLORS: Record<string, string> = {
  superadmin: 'bg-violet-100 text-violet-700 border-violet-200',
  admin: 'bg-blue-100 text-blue-700 border-blue-200',
  user: 'bg-slate-100 text-slate-600 border-slate-200',
};
